import { useEffect } from 'react';
import { useGetHostedEventsByUserIdLazyQuery } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';
import { PlayerDiscover } from 'screens/PlayerLoggedInScreen/components';
import HostedEvents from 'components/HostedEvents';
import CoachDashboardHeader from './CoachDashboardHeader';
import OutstandingRecaps from './OutstandingRecaps';
import OutstandingVideoAnalysis from './OutstandingVideoAnalysis';
import ProfileCompleteness from './ProfileCompleteness';
import TodayLessons from './TodayLessons';
import OnboardingVideos from '../OnboardingSteps/OnboardingVideos';

const CoachDashboard = () => {
  const viewer = useViewer();
  const [
    getHostedEvents,
    { data: dataHostedEvents, loading: hostedEventsLoading, called: hostedEventsCalled },
  ] = useGetHostedEventsByUserIdLazyQuery();

  useEffect(() => {
    if (viewer.userId) {
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      getHostedEvents({
        variables: {
          userId: viewer.userId,
        },
        fetchPolicy: 'network-only',
      });
    }
  }, [viewer.userId, getHostedEvents]);

  const separator = (
    <hr className="container mx-auto mt-8 border-color-bg-input-lightmode-primary dark:border-color-bg-input-darkmode-primary max-sm:mt-ds-xl" />
  );

  return (
    <>
      <CoachDashboardHeader />
      <TodayLessons />
      <HostedEvents
        events={dataHostedEvents?.events ?? []}
        loading={hostedEventsLoading || !hostedEventsCalled}
      />

      <ProfileCompleteness />
      {separator}
      <OutstandingRecaps />
      {separator}
      <OutstandingVideoAnalysis />
      {/* hidden for mvp */}
      {/* {separator}
      <Stats /> */}
      {separator}
      <PlayerDiscover className="mt-8" borderBottom={false} />
      {/* hiding for mvp */}
      {/* {separator}
      <OnboardingVideos className="mt-8" /> */}
    </>
  );
};

export default CoachDashboard;
